import { Show, type JSX } from 'solid-js'
import type { ViewProps } from 'wdc-cube-solid'
import {
    ACTION_COLUMN,
    type CompaniesScope,
    type CompanyColumnField,
    type CompanyRowScope
} from 'mormaii-web-presentation/companies'

import { Button, ChoiceFilter, TextFilter } from '../../../components/filters'
import { DataTable, Pager } from '../../../components/table'
import { ErrorNotice, Panel } from '../../../components/ui'

import Css from './companies.module.scss'

/**
 * A lista de empresas.
 *
 * Diferente de Colaboradores em uma coisa que muda o desenho: aqui a listagem E a
 * aterrissagem do conceito - ela nunca sai da tela. O que vem depois (editar, e a
 * confirmacao de bloquear ou remover) e desenhado POR CIMA, num dialogo, e por isso
 * sao places FILHOS e nao irmaos.
 */
export function CompaniesView(props: ViewProps<CompaniesScope>): JSX.Element {
    const submit = (event: Event) => {
        event.preventDefault()
        void props.scope.onSubmit()
    }

    return (
        <Show when={!props.scope.error} fallback={<ErrorNotice message={props.scope.error!} />}>
            <div class={Css.screen} aria-busy={props.scope.loading}>
                {/*
                    A faixa ESCURA de filtros, a mesma do Painel, da Adocao e Engajamento, do
                    Relatorio de Sono e dos Monitoramentos. Ate 18/09/2026 esta tela usava
                    um `Panel` branco, e era a ultima que fazia isso.

                    Sem botao de aplicar: o filtro vale sozinho conforme se mexe nele -
                    o texto depois de parar de digitar, o status na hora. Sobra o Limpar.
                */}
                <form onSubmit={submit}>
                    <section class={Css.filterBar}>
                        <div class={Css.haloTop} />
                        <div class={Css.haloBottom} />

                        <div class={Css.filterBarBody}>
                            <h2 class={Css.filterBarTitle}>Filtrar empresas</h2>

                            <div class={Css.controls}>
                                <TextFilter
                                    onDark
                                    label="CNPJ"
                                    placeholder="Busca parcial"
                                    value={props.scope.cnpj}
                                    onChange={(value) => props.scope.onCnpjChanged(value)}
                                />
                                <TextFilter
                                    onDark
                                    label="Razão social"
                                    placeholder="Busca parcial"
                                    value={props.scope.razaoSocial}
                                    onChange={(value) => props.scope.onRazaoSocialChanged(value)}
                                />
                                <TextFilter
                                    onDark
                                    label="Nome fantasia"
                                    placeholder="Busca parcial"
                                    value={props.scope.nomeFantasia}
                                    onChange={(value) => props.scope.onNomeFantasiaChanged(value)}
                                />
                                <TextFilter
                                    onDark
                                    label="Ramo de atividade"
                                    placeholder="Busca parcial"
                                    value={props.scope.ramoAtividade}
                                    onChange={(value) => props.scope.onRamoAtividadeChanged(value)}
                                />
                                <TextFilter
                                    onDark
                                    label="Contato"
                                    placeholder="Busca parcial"
                                    value={props.scope.contactName}
                                    onChange={(value) => props.scope.onContactNameChanged(value)}
                                />
                                <TextFilter
                                    onDark
                                    label="E-mail do contato"
                                    placeholder="Busca parcial"
                                    value={props.scope.contactEmail}
                                    onChange={(value) => props.scope.onContactEmailChanged(value)}
                                />
                                <TextFilter
                                    onDark
                                    label="Telefone do contato"
                                    placeholder="Busca parcial"
                                    value={props.scope.contactPhone}
                                    onChange={(value) => props.scope.onContactPhoneChanged(value)}
                                />

                                <Show when={props.scope.statusFilter}>
                                    {(filter) => (
                                        <ChoiceFilter
                                            onDark
                                            label={filter().label}
                                            summary={filter().summary}
                                            placeholder="Todos"
                                            hasValue={filter().active}
                                            onClear={() => {
                                                const todos = filter().options.find((option) => !option.value)
                                                void todos?.onSelect()
                                            }}
                                            options={filter().options.map((option) => ({
                                                label: option.label,
                                                value: option.value,
                                                current: option.current,
                                                onSelect: option.onSelect
                                            }))}
                                        />
                                    )}
                                </Show>

                                <Button
                                    variant="glass"
                                    class={Css.clear}
                                    onClick={() => void props.scope.onClearFilters()}
                                >
                                    Limpar
                                </Button>
                            </div>
                        </div>
                    </section>
                </form>

                <Panel
                    title="Lista de empresas"
                    actions={
                        <Button onClick={() => void props.scope.onNew()}>
                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                class={Css.plusIcon}
                            >
                                <path d="M12 5v14M5 12h14" />
                            </svg>
                            Cadastrar empresa
                        </Button>
                    }
                    flush
                >
                    <DataTable
                        columns={[
                            ...props.scope.columns.map((column) => ({
                                field: column.field,
                                label: column.label,
                                sortable: true,
                                sorted: column.sorted,
                                descending: column.descending,
                                onSort: column.onSort,
                                movable: column.movable,
                                onDrop: (source: string) => column.onDrop(source)
                            })),
                            /*
                                A coluna de ACAO e montada AQUI, e nao pela
                                apresentacao: ela nao ordena por nada e nao tem campo
                                no servidor - e so o lugar onde os botoes cabem. Por
                                isso tambem nao aparece na lista branca de ordenacao.
                            */
                            {
                                field: ACTION_COLUMN,
                                label: 'Ação',
                                sortable: false,
                                sorted: false,
                                descending: false,
                                onSort: async () => {}
                            }
                        ]}
                        rows={props.scope.rows}
                        loading={props.scope.loading}
                        cell={(row, field) =>
                            field === ACTION_COLUMN
                                ? companyActions(row)
                                : companyCell(row, field as CompanyColumnField)
                        }
                        pinLast
                        layout={props.scope.layout}
                        emptyText={
                            props.scope.anyFilterActive
                                ? 'Nenhuma empresa encontrada com os filtros aplicados'
                                : 'Nenhuma empresa cadastrada'
                        }
                    />

                    <Pager
                        page={props.scope.page}
                        pageCount={props.scope.pageCount}
                        pages={props.scope.pageWindow}
                        total={props.scope.total}
                        onPrevious={() => void props.scope.onPreviousPage()}
                        onNext={() => void props.scope.onNextPage()}
                        onGoTo={(page) => void props.scope.onGoToPage(page)}
                    />
                </Panel>
            </div>
        </Show>
    )
}

/**
 * As celulas de uma linha, na ORDEM das colunas de `company-table.ts`.
 *
 * A ordem importa e nao e obvia: contato e status vem ANTES de ramo de atividade e
 * usuarios, porque as cinco primeiras sao as do painel antigo e as duas ultimas sao
 * acrescimo. Escrever a ordem "logica" aqui desalinha a tabela inteira - o
 * cabecalho dizia "contato responsável" sobre o ramo de atividade.
 *
 * E-mail e telefone do contato sao campos de FILTRO, e nao colunas.
 */
/** A celula de uma coluna, pelo campo dela - a ordem das colunas e a que a pessoa escolheu. */
function companyCell(row: CompanyRowScope, field: CompanyColumnField): JSX.Element {
    switch (field) {
        case 'cnpj':
            return <span class={Css.number}>{row.cnpj}</span>
        case 'razao':
            return (
                <button
                    type="button"
                    onClick={() => void row.onViewCollaborators()}
                    title="Ver os colaboradores desta empresa"
                    class={Css.drillDown}
                >
                    {row.razaoSocial}
                </button>
            )
        case 'fantasia':
            return <span>{row.nomeFantasia}</span>
        case 'contato':
            return <span>{row.contactName}</span>
        case 'status':
            return (
                <span class={Css.status} classList={{ [Css.active]: row.active }}>
                    {row.active ? 'Ativa' : 'Bloqueada'}
                </span>
            )
        case 'ramo':
            return <span>{row.ramoAtividade}</span>
        case 'usuarios':
            return <span class={Css.number}>{row.totalUsers ?? '-'}</span>
        default: {
            // Todo campo tem a sua celula: um campo novo sem `case` nao compila - e, se
            // escapar (um campo vindo de fora do tipo), a celula fica vazia, e nao com o
            // nome do campo escrito.
            const semCelula: never = field
            void semCelula
            return <span />
        }
    }
}

/** As acoes vao na ULTIMA coluna, que a tabela prende na borda (`pinLast`). */
function companyActions(row: CompanyRowScope): JSX.Element {
    return (
        <div class={Css.rowActions}>
            <RowAction label="Editar" onClick={() => void row.onEdit()}>
                <path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
            </RowAction>

            <RowAction
                label={row.active ? 'Bloquear acesso' : 'Liberar acesso'}
                onClick={() => void row.onToggleAccess()}
            >
                <Show when={row.active} fallback={<path d="M7 11V7a5 5 0 0 1 9.9-1M5 11h14v10H5z" />}>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4M5 11h14v10H5z" />
                </Show>
            </RowAction>

            <RowAction label="Remover" danger onClick={() => void row.onDelete()}>
                <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6" />
            </RowAction>
        </div>
    )
}

function RowAction(props: {
    label: string
    onClick: () => void
    danger?: boolean
    children: JSX.Element
}): JSX.Element {
    return (
        <button
            type="button"
            aria-label={props.label}
            title={props.label}
            onClick={props.onClick}
            class={Css.rowAction}
            classList={{ [Css.danger]: props.danger }}
        >
            <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                {props.children}
            </svg>
        </button>
    )
}
